export enum StoreProductType {
    PRODUCT_INSTANCE = "productInstance",
    STORE_PRODUCT = "storeProduct",
    PROPERTY_MODEL = "propertyModel"
}

export enum OrigStoreProductType {
    PRODUCT_INSTANCE_ID = "productInstanceId",
    STORE_PRODUCT_ID = "storeProductId",
    PROPERTY_MODEL_ID = "propertyModelId"
}